module.exports = new __parcel__URL__("Business Status Update.1efc1ace.svg").toString();